<a-scene
  vr-mode-ui="enabled: false;"
  renderer="logarithmicDepthBuffer: true;"
  embedded
  arjs="trackingMethod: best; sourceType: webcam; debugUIEnabled: false;"
>
  @for (quest of quests; track quest) {
    <a-marker
      type="pattern"
      [attr.url]="'assets/markers/' + quest + '/pattern-icon.patt'"
      (markerFound)="getQuestionFromQuest(quest)"
    >
      <!--a-image
        position="0 0.5 0"
        rotation="90 180 0"
        scale="-1.5 1.5 1.5"
        [attr.src]="'assets/images/' + quest + '/quest.png'"
      ></a-image-->
    </a-marker>
  }
  <a-entity camera></a-entity>
</a-scene>
